/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_RegistrationInputs */

const en_page_title_registration = /** @type {(inputs: Page_Title_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration`)
};

const de_page_title_registration = /** @type {(inputs: Page_Title_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung`)
};

/**
* | output |
* | --- |
* | "Registration" |
*
* @param {Page_Title_RegistrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const page_title_registration = /** @type {((inputs?: Page_Title_RegistrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_RegistrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_page_title_registration(inputs)
	return en_page_title_registration(inputs)
});